/**
 * Open state of the declared-action and dispatch dialogs: `openDeclaredAction()` and
 * `openDispatch()` work from anywhere (a problem row, the board, a project's menu);
 * <ProjectHealthHosts /> in the shell shows them.
 */
import type { Id } from '@orgus/protocol';
import { create } from 'zustand';

export interface ActionTarget {
  projectId: Id;
  machineId: Id;
  actionId: string;
  /** Open on this run (from a list of runs) rather than on the confirmation. */
  runId?: Id;
}

interface DialogStore {
  action: ActionTarget | null;
  /** The problem a fix is dispatched for. */
  dispatch: string | null;
}

export const usePpDialogs = create<DialogStore>()(() => ({ action: null, dispatch: null }));

export function openDeclaredAction(t: ActionTarget): void {
  usePpDialogs.setState({ action: t, dispatch: null });
}

export function openDispatch(problemKey: string): void {
  usePpDialogs.setState({ dispatch: problemKey, action: null });
}

export function closePpDialogs(): void {
  usePpDialogs.setState({ action: null, dispatch: null });
}
